import './PDP/featured-gallery';
import './PDP/btn-discount';
import './sections/reviews-carousel';
import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import './snippets/shipping-protection';

window.initSlider = function(idElement, options = {}){
    return new Swiper(idElement, {
        modules: [Navigation, Pagination, Autoplay],
        ...options
    });
};